import BasePage from "../../../base/BasePage";
import React from "react";
import RegionTab from "../../../components/common/RegionTab";
import RecipientLogPage from "./SpecialAwardTable/RecipientLogPage";
import ListOfSpecialAward from "./SpecialAwardTable/ListOfSpecialAward";

class SpecialAwardPage extends BasePage {
  constructor(props) {
    super(props);
    this.state = {};
  }

  render() {
    const tabs = [
      { title: "Recipient Logs", content: <RecipientLogPage /> },
      { title: "List of Special Awards", content: <ListOfSpecialAward /> },
    ];
    const tabContents = tabs.map((tab) => tab.content);
    return (
      <>
        <div
          className="container-fluid d-flex flex-column p-5"
          style={{ marginTop: "4rem" }}
        >
          <div
            className="d-flex mb-4"
            style={{ borderBottom: "1px solid #d3d3d3" }}
          >
            <p style={{ fontSize: "14px", color: "grey" }}>
              You are here: Home &gt; Merit Reward and Recognition &gt;{" "}
              <span style={{ color: "#333" }}>Special Award</span>
            </p>
          </div>
          <RegionTab tabs={tabs} tabContents={tabContents} />
        </div>
      </>
    );
  }
}

export default SpecialAwardPage;
